
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import { partnerEntity } from '@/models/models'
import { ChildComponentMixin } from '@/mixins'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
    },
})

export default class PartnerFormOptionalData extends ChildComponentMixin {
    @Prop() public value?: PartnerEntity

    get partner(): PartnerEntity {
        return this.value ?? partnerEntity
    }
}
